import { render, staticRenderFns } from "./TrasladarCotizacionModal.vue?vue&type=template&id=b5f32ba6&scoped=true&"
import script from "./TrasladarCotizacionModal.vue?vue&type=script&lang=js&"
export * from "./TrasladarCotizacionModal.vue?vue&type=script&lang=js&"
import style0 from "./TrasladarCotizacionModal.vue?vue&type=style&index=0&id=b5f32ba6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f32ba6",
  null
  
)

export default component.exports